import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module core/contextplugin
 */
import { ObservableMixin } from '@ckeditor/ckeditor5-utils';
/**
 * The base class for {@link module:core/context~Context} plugin classes.
 *
 * A context plugin can either be initialized for an {@link module:core/editor/editor~Editor editor} or for
 * a {@link module:core/context~Context context}. In other words, it can either
 * work within one editor instance or with one or more editor instances that use a single context.
 * It is the context plugin's role to implement handling for both modes.
 *
 * There are a few rules for interaction between the editor plugins and context plugins:
 *
 * * A context plugin can require another context plugin.
 * * An {@link module:core/plugin~Plugin editor plugin} can require a context plugin.
 * * A context plugin MUST NOT require an {@link module:core/plugin~Plugin editor plugin}.
 */
var ContextPlugin = /*#__PURE__*/function (_ObservableMixin) {
  _inherits(ContextPlugin, _ObservableMixin);
  var _super = _createSuper(ContextPlugin);
  /**
   * Creates a new plugin instance.
   */
  function ContextPlugin(context) {
    var _this;
    _classCallCheck(this, ContextPlugin);
    _this = _super.call(this);
    _this.context = context;
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(ContextPlugin, [{
    key: "destroy",
    value: function destroy() {
      this.stopListening();
    }
    /**
     * @inheritDoc
     */
  }], [{
    key: "isContextPlugin",
    get: function get() {
      return true;
    }
  }]);
  return ContextPlugin;
}(ObservableMixin());
export { ContextPlugin as default };